export default {
  subtitle: "Requesting Authorization for Bank Accounts ",
  path: "requesting_authorization",
  paragraphs: [
    "This feature is available upon agreement. The first step is to create an authorization for opening a pay-in (collections) account, choosing either if the owner of the account will be the customer or not. Then, the request will be analyzed by our payment desk (Backoffice).",
    "If approved, you will be able to send a request to open an account in the next section endpoint, named 'Requesting Bank Accounts'. If reproved, you will also know the reason. In either case, you will receive a webhook with the updated status.",
  ],
  request:  {
    method: "POST",
    endpoint: "/subject/:id/account_request",
    payloads: [
        {
        title: "This determines whether the subject is going to be the owner of the bank account. If true, payments to this bank account will be handled by this subject's document number. If false (default), the account will be registered under FacilitaPay's name. You can set this parameter to true only if your customer has a CPF or CNPJ. Note that the payload is not necessary if there is no need for your subject to be the owner of the bank account as the default value is false.",
        content: { 
        "is_subject_account_owner": false 
        }
     },
     {
        title: "This is the webhook that will be sent once the approval is given by the Backoffice. If, for any reason, it is reproved, the reason field will contain the reason(s). Notice you can use the subject_id to associate with your customer.",
        content: {
        "notification": { 
            "reason": null, 
            "subject_id": "93de033d-78db-42f3-9fb6-d2b0abb9a95e", 
            "status": "approved", 
            "type": "subject_account_authorization" 
            } 
        }
     }
    ],
    responses: { 
      "data": { 
        "updated_at": "2025-06-09T20:04:54.255186", 
        "subject_id": "93de033d-78db-42f3-9fb6-d2b0abb9a95e", 
        "status": "pending", 
        "reason": null, 
        "is_subject_account_owner": false, 
        "inserted_at": "2025-06-09T20:04:54.255176", 
        "id": "96abf5e5-3067-4f42-8626-7cc4eda0c05b " 
        }
    }
},
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Where id is your customer’s UUID within FacilitaPay. Must be from a subject that has either a cpf, cnpj or tax_id as document_number. "
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/MarketplaceCollection/RequestingAuthorization.js